import * as React from 'react'

import {Button, Form, Input, message} from 'antd';
import {FormComponentProps} from "antd/lib/form";
import {observer} from "mobx-react";
import {ViewBaseComponent} from "../../../src/views/ViewComponentBase";
import commonStyles from '../../../src/styles/common.scss';
// kix-gbc Web用のAPIパス（セッション認証）
const KIX_GBC_API_PATH = "/api/kix_gbc";
import appStyles from '../../assets/css/app.scss';
import {action, observable, runInAction} from "mobx";
import {BaseValidations} from "../../../src/utils/form/validate/BaseValidations";
import {HttpUtils} from "../../../src/utils/Http/HttpUtils";
import KixGbcMemberLayout from "../../layouts/KixGbcMemberLayout/KixGbcMemberLayout";
import {loginUserStore} from "../../store/Login/LoginUserStore";
import json = HttpUtils.json;

const FormItem = Form.Item;

@observer
class FirstSetting extends ViewBaseComponent<{} & FormComponentProps, {}> {
  formUtils = this.props.form;

  @observable
  sended = false;

  componentWillMount() {
  }

  componentWillUnmount() {
  }

  @action
  handleSubmit = () => {
    this.formUtils.validateFields((err, _values: any) => {
      if (!err) {
        let body = {
          email: this.formUtils.getFieldValue("email"),
          pass: this.formUtils.getFieldValue("password"),
        };
        json(KIX_GBC_API_PATH + "/first_account_setting",
          "POST",
          body,
        ).then((res: any) => {
          const json = res.content;
          runInAction(() => {
            if (json.result.code == 1) {
              this.sended = true;
            } else {
              message.error(json.result.message);
            }
          });
        }).catch(() => {
          message.error("通信に失敗しました。もう一度お試し下さい。");
        });
      }
    });
  };

  @action
  handleToTop = () => {
    loginUserStore.logout();
  };

  @action
  validatePass = (_rule: any, value: string, callback: (error?: string) => void): void => {
    if (/[0-9]+/.test(value) && /[a-z]+/.test(value) && /[A-Z]+/.test(value)) {
      callback();
    } else {
      callback("パスワードは８文字以上、半角英字小文字、半角英字大文字、数字を全て含めて入力してください。");
    }
  };

  render() {
    const {getFieldDecorator} = this.props.form;

    return (
      <>
        <KixGbcMemberLayout notFirstSetting={true}>
        <h2 className={appStyles.h2blue} style={{marginTop: "2em", marginBottom: "2em"}}>初期アカウント設定</h2>

        {!this.sended ?
          <>
            <p style={{color: "white"}}>メールアドレスとパスワードを設定して
              “送信”ボタンをクリックしてください。
            </p>

            <span className={appStyles.h3White} style={{fontSize: "1em"}}>メールアドレス</span>
            <FormItem>
              {getFieldDecorator('email', {
                validateTrigger: "onBlur",
                rules: [
                  BaseValidations.required,
                  BaseValidations.email,
                ],
              })(
                <Input size="large"
                       placeholder="メールアドレス" onBlur={() => this.formUtils.setFieldsValue({"email_confirm": this.formUtils.getFieldValue("email_confirm")})}/>
              )}
            </FormItem>

            <span className={appStyles.h3White} style={{fontSize: "1em"}}>メールアドレス(確認)</span>
            <FormItem>
              {getFieldDecorator('email_confirm', {
                validateTrigger: "onBlur",
                rules: [
                  BaseValidations.required,
                  BaseValidations.sameWith(this.formUtils, "email", "メールアドレスが確認用欄と一致しません。"),
                ],
              })(
                <Input size="large"
                       placeholder="メールアドレス(確認)" onPaste={(e: any) => e.preventDefault()}/>
              )}
            </FormItem>

            <span className={appStyles.h3White} style={{fontSize: "1em"}}>パスワード</span>
            <FormItem>
              {getFieldDecorator('password', {
                validateTrigger: "onBlur",
                rules: [
                  BaseValidations.required,
                  BaseValidations.minLen(8),
                  BaseValidations.maxLen(64),
                  {validator: (_rule: any, value: string, cb: (error?: string) => void) => this.validatePass(_rule, value, cb)},
                ],
              })(
                <Input size="large" type={"password"}
                       name="password"
                       autoComplete="off"
                       placeholder="パスワード" onBlur={() => this.formUtils.setFieldsValue({"password_confirm": this.formUtils.getFieldValue("password_confirm")})}/>
              )}
            </FormItem>

            <span className={appStyles.h3White} style={{fontSize: "1em"}}>パスワード(確認)</span>
            <FormItem>
              {getFieldDecorator('password_confirm', {
                validateTrigger: "onBlur",
                rules: [
                  BaseValidations.required,
                  BaseValidations.sameWith(this.formUtils, "password"),
                ],
              })(
                <Input size="large" type={"password"}
                       name="password_confirm"
                       autoComplete="off"
                       placeholder="パスワード(確認)" onPaste={(e: any) => e.preventDefault()}/>
              )}
            </FormItem>

            <div className={commonStyles.fCenter + " " + commonStyles.mt30}>
              <FormItem>
                <Button style={{padding: "0.5em 6em 0.5em 6em", margin: "1em 0 1em 0"}} type="primary"
                        size="large" className={appStyles.buttonBlue}
                        onClick={this.handleSubmit}
                >
                  送信
                </Button>
              </FormItem>
            </div>
          </> : <>
            <p style={{color: "white", fontWeight:"bold"}}>
              入力したメールアドレス宛にメールを送信しました。
            </p>
            <p style={{color: "white", fontWeight:"bold"}}>
              メール内のURLにアクセスして設定を完了してください。
            </p>
            <p style={{color: "white", fontWeight:"bold"}}>
              メールが届かない場合は入力したメールアドレスが誤っている可能性がありますので再度送信してください。
            </p>

            <div className={commonStyles.fCenter + " " + commonStyles.mt30}>
              <FormItem>
                <Button style={{padding: "0.5em 6em 0.5em 6em", margin: "1em 0 1em 0"}} type="primary"
                        size="large" className={appStyles.buttonBlue}
                        onClick={() => this.handleToTop()}
                >
                  戻る
                </Button>
              </FormItem>
            </div>
          </>
        }
      </KixGbcMemberLayout>
      </>
    );
  }
}

export default Form.create()(FirstSetting)

